import { PageTitle } from '@/components/seo/page-title';
import { SecurityScreen } from '@/screens/settings/security-screen';
import React from 'react';

export default function SecurityRoute() {
  return (
    <>
      <PageTitle title="Sign-in & Security" />
      <SecurityScreen />
    </>
  );
}
